import { t } from 'i18next'
import { isBoolean } from 'lodash'
import { load } from 'scrivito'

import { getReferenceDataClass } from './getDataClass'
import { SchemaAttribute } from '@/Data/typesV2'
import { getDataItemTitle } from '@/utils/dataClassMap'
import { dataScopeHasMore } from '@/utils/dataScopeHasMore'

/**
 * Util function to filter the selectable options for an attribute of type `Reference`
 * @param attribute
 * @returns a promise load function for the drop down menu
 */
export const getReferenceOptionsFunction = (attribute?: SchemaAttribute) => {
  const { referenceTo, referenceFilter } = attribute || {}

  if (!referenceTo) return

  const dataClass = getReferenceDataClass(referenceTo, referenceFilter)

  if (!dataClass) return

  const getOptions = async (inputValue: string) => {
    const dataScope = dataClass.all()
    const limit = 20

    const isExternal = isBoolean(referenceFilter?.isExternal)
      ? { isExternal: referenceFilter?.isExternal }
      : null

    const transform = {
      search: inputValue,
      limit,
      filters: { ...isExternal },
    }

    const options = await load(() => dataScope.transform(transform).take())

    const resultOptions = options.map((e) => ({
      label: getDataItemTitle(e) as string,
      value: e.id(),
    }))

    const hasMore = await load(() =>
      dataScopeHasMore(dataClass.all(), transform, limit),
    )

    const result = hasMore
      ? [
          ...resultOptions,
          {
            label: t('search.typeForMoreOptions'),
            value: '',
            isDisabled: true,
          },
        ]
      : resultOptions

    return result
  }

  const loadReferenceOptions = (inputValue: string) =>
    new Promise<{ label: string; value: string }[]>((resolve) => {
      resolve(getOptions(inputValue))
    })

  return loadReferenceOptions
}
